import { render, staticRenderFns } from "./myInquiryListSearch.vue?vue&type=template&id=82bf3228&scoped=true"
import script from "./myInquiryListSearch.vue?vue&type=script&lang=js"
export * from "./myInquiryListSearch.vue?vue&type=script&lang=js"
import style0 from "./myInquiryListSearch.vue?vue&type=style&index=0&id=82bf3228&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82bf3228",
  null
  
)

export default component.exports